import type { LucideIcon } from "lucide-react";
import { CirclePower } from "lucide-react";
import { Spinner } from "./Spinner";

/**
 * On/off tile (pool circuit anatomy, spec §4.1): 22px radius, icon top-left,
 * power glyph or spinner top-right, label + On/Off caption at the bottom.
 */
export function ToggleTile({
  icon: Icon,
  label,
  on,
  pending = false,
  disabled = false,
  tint = "var(--pool)",
  activeBg = "var(--pool-soft)",
  onToggle
}: {
  icon: LucideIcon;
  label: string;
  on: boolean;
  pending?: boolean;
  disabled?: boolean;
  /** CSS color when on. */
  tint?: string;
  /** Tile background when on. */
  activeBg?: string;
  onToggle: () => void;
}) {
  const color = on ? tint : "var(--muted)";
  return (
    <button
      type="button"
      className="toggle-tile"
      style={
        on
          ? { background: activeBg, borderColor: `color-mix(in srgb, ${tint} 34%, transparent)` }
          : undefined
      }
      disabled={disabled || pending}
      aria-pressed={on}
      onClick={onToggle}
    >
      <span className="toggle-tile-top">
        <Icon size={22} strokeWidth={2.6} style={{ color }} />
        {pending ? <Spinner size={16} /> : <CirclePower size={22} strokeWidth={on ? 2.6 : 2.1} style={{ color }} />}
      </span>
      <span className="toggle-tile-text">
        <span className="toggle-tile-label">{label}</span>
        <span className="toggle-tile-state">{on ? "On" : "Off"}</span>
      </span>
    </button>
  );
}
